import ErrorHandlerContainer from 'components/ErrorHandler/ErrorHandlerContainer'
import ErrorHandlerPresentation from 'components/ErrorHandler/ErrorHandlerPresentation'
import ErrorHandlerData from 'components/ErrorHandler/ErrorHandlerData'

export default {
  Container: ErrorHandlerContainer,
  Presentation: ErrorHandlerPresentation,
  Data: ErrorHandlerData,
}
